import React, { useState, useEffect } from "react";
import { TemplateConfirmationPrelevement, TemplateErreurPrelevement } from './../../Templates/index';
import { apiPostConsentement } from "../../Api/Payment/Payment";

const ConfirmationPrelevement = () => {
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(true);
  const CONFIRMATION_PRELEVEMENT_OK = true;

  useEffect(() => {
    // Fonction pour enregistrer la demande de consentement
    const fetchConsentement = async () => {
      try {
        const body = {
          isConsent: CONFIRMATION_PRELEVEMENT_OK
        };
        const res = await apiPostConsentement(body);
        setStatus(res.status);
        console.log('apiPostConsentement: ', res);
      }
      catch (error) {
        console.error("Erreur lors de l'appel API:", error);
        setStatus("error");
      }
      finally {
        setLoading(false);
      }
    };

    fetchConsentement();
  }, []);

  if (loading) {
    return <div>Chargement en cours...</div>;
  }

if (status === 200) {
    return (
      <TemplateConfirmationPrelevement
        // Confirmation du prélèvement
        confirmation={CONFIRMATION_PRELEVEMENT_OK}
      />    
    );
  }
  else {
    return (
      // Template erreur
      <TemplateErreurPrelevement />
    )    
  }
};

export default ConfirmationPrelevement;